export const ADMIN_LIST="/admin/list";
export const ADMIN_QUANTITY="/admin/quantity";
export const ADMIN_INFO="/admin/info";
export const ADMIN_AUTHENTICATE="/admin/authenticate";
export const ADMIN_UNAUTHENTICATE="/admin/unauthenticate";
export const ADMIN_LOCK="/admin/lock";
export const ADMIN_UNLOCK="/admin/unlock";
export const ADMIN_ENABLE="/admin/enable";
export const ADMIN_DISABLE="/admin/disable";
export const ADMIN_LOGOUT="/admin/logout";
export const ADMIN_RESTORE="/admin/restore";
export const ADMIN_ACCOUNT_EXPIRED="/admin/accountExpired";
export const ADMIN_ACCOUNT_UNEXPIRED="/admin/accountUnexpired";
export const ADMIN_PASSWORD_EXPIRED="/admin/passwordExpired";
export const ADMIN_PASSWORD_UNEXPIRED="/admin/passwordUnexpired";
export const ADMIN_PASSWORD_RESET="admin/password/reset";